import { ASSET_STORAGE_URL, IMAGE_URL_PREFIX, PUBLIC_URL } from '../../config';
import { throwDevelopmentOrLog } from './errorUtilities';
export const images = {
  get apiPackage() {
    return `${PUBLIC_URL}images/api_package.png`;
  },
  get astro() {
    return `${PUBLIC_URL}images/Astro.png`;
  },
  get approvalConfetti() {
    return `${PUBLIC_URL}images/ApprovalConfetti.png`;
  },
  get appyArrow() {
    return `${PUBLIC_URL}images/Appy_Arrow.svg`;
  },
  get appyHeader() {
    return `${PUBLIC_URL}images/header-appy.svg`;
  },
  get appyPlane() {
    return `${PUBLIC_URL}images/Appy_Plane.png`;
  },
  get appyCloseUp() {
    return `${PUBLIC_URL}images/Appy_Close_Up.png`;
  },
  get confetti() {
    return `${PUBLIC_URL}images/Confetti.png`;
  },
  get salesforceLogo() {
    return `${PUBLIC_URL}images/logo-salesforce.svg`;
  },
  get illustrationBird() {
    return `${PUBLIC_URL}images/illustration-bird.png`;
  },
  get illustrationBirdLog() {
    return `${PUBLIC_URL}images/illustration-bird-log.png`;
  },
  get illustrationTree() {
    return `${PUBLIC_URL}images/illustration-tree.png`;
  },
  get illustrationAppyStroll() {
    return `${PUBLIC_URL}images/illustration-appy-stroll.png`;
  },
  get errorBird() {
    return `${PUBLIC_URL}images/error-bird.png`;
  },
  get goat() {
    return `${PUBLIC_URL}images/goat.png`;
  },
  get syncedPlan() {
    return `${PUBLIC_URL}images/synced-plan.svg`;
  },
  get notSyncedPlan() {
    return `${PUBLIC_URL}images/not-synced-plan.svg`;
  },
  get treesAndMountain() {
    return `${PUBLIC_URL}images/footer/Trees-And-Mountain.png`;
  },
  get smallTrees() {
    return `${PUBLIC_URL}images/Small-Trees.png`;
  },
  get treeAndApp() {
    return `${PUBLIC_URL}images/tree-and-app.png`;
  },
  get treeAndButterfly() {
    return `${PUBLIC_URL}images/Tree-And-Butterfly.png`;
  },
  get treeSquirrelButterfly() {
    return `${PUBLIC_URL}images/treeSquirrelButterfly.png`;
  },
  get cloud() {
    return `${PUBLIC_URL}images/light-cloud.png`;
  },
  get butterfly() {
    return `${PUBLIC_URL}images/Butterfly.png`;
  },
  get mountains() {
    return `${PUBLIC_URL}images/Mountains.png`;
  },
  get forest() {
    return `${PUBLIC_URL}images/Forest.png`;
  },
  get salesforce() {
    return `${PUBLIC_URL}images/footer/salesforce.svg`;
  },
  get twitter() {
    return `${PUBLIC_URL}images/footer/tw.svg`;
  },
  get linkedIn() {
    return `${PUBLIC_URL}images/footer/in.svg`;
  },
  get faceBook() {
    return `${PUBLIC_URL}images/footer/fb.svg`;
  },
  get rss() {
    return `${PUBLIC_URL}images/footer/rss.svg`;
  },
  get company() {
    return `${PUBLIC_URL}images/company.svg`;
  },
  get defaultAppIcon() {
    return `${PUBLIC_URL}images/default-app-icon.svg`;
  },
  get validating() {
    return `${PUBLIC_URL}images/Validating.png`;
  },
  get emptyState() {
    return `${PUBLIC_URL}images/empty-state.png`;
  },
  get emptyStatePricingConfigurator() {
    return `${PUBLIC_URL}images/empty-state-pricing-configurator.png`;
  },
  get listingsEmptyState() {
    return `${PUBLIC_URL}images/listings-empty-state.svg`;
  },
  get notFound() {
    return `${PUBLIC_URL}images/not-found.png`;
  },
  get stripeLeftBars() {
    return `${PUBLIC_URL}images/stripe-left-bars.svg`;
  },
  get stripeLogo() {
    return `${PUBLIC_URL}images/stripe-logo.png`;
  },
  get stripeRightBar() {
    return `${PUBLIC_URL}images/stripe-right-bars.svg`;
  },
  get stripe() {
    return `${PUBLIC_URL}images/stripe.svg`;
  },
  get connectOrg() {
    return `${PUBLIC_URL}images/connectOrg.png`;
  },
  get appyForest() {
    return `${PUBLIC_URL}images/appy_forest.png`;
  },
  get srLoading() {
    return `${PUBLIC_URL}images/sr-loading.png`;
  },
  get appyTrees() {
    return `${PUBLIC_URL}images/appy_trees.png`;
  },
  get isvDevCenterLogo() {
    return `${PUBLIC_URL}images/app-launcher/isv-dev-center.svg`;
  },
  get eventsLogo() {
    return `${PUBLIC_URL}images/app-launcher/events.svg`;
  },
  get salesforceHelpLogo() {
    return `${PUBLIC_URL}images/app-launcher/help.svg`;
  },
  get trailblazerLogo() {
    return `${PUBLIC_URL}images/app-launcher/trailblazer-community.svg`;
  },
  get trailheadLogo() {
    return `${PUBLIC_URL}images/app-launcher/trailhead.svg`;
  },
  get partnerCommunityLogo() {
    return `${PUBLIC_URL}images/app-launcher/partner-community.svg`;
  },
  get stripeIcon() {
    return `${PUBLIC_URL}images/stripe-icon.svg`;
  },
  get add() {
    return `${PUBLIC_URL}images/add.svg`;
  },
  get forestCircle() {
    return `${PUBLIC_URL}images/forest-circle.png`;
  },
  get checkIcon() {
    return `${PUBLIC_URL}images/check.svg`;
  },
  get closeIcon() {
    return `${PUBLIC_URL}images/close.svg`;
  }
};
export const styles = {
  get backgroundCloud() {
    return `background-image: url('${PUBLIC_URL}images/background_tile.png');`;
  },
  get backgroundPublisher() {
    return `background-image: url('${PUBLIC_URL}images/publisher_background.png');`;
  },
  get appyPlane() {
    return `background-image: url('${PUBLIC_URL}images/Appy_Plane.png');`;
  }
};
export function generateMediaUrlImage(mediaId) {
  return mediaId.startsWith(IMAGE_URL_PREFIX) ? mediaId : `${ASSET_STORAGE_URL}/${mediaId}`;
}
export function generateMediaUrlVideo(mediaId, videoType = 'YouTube') {
  switch (videoType) {
    case 'YouTube':
      return 'https://img.youtube.com/vi/' + mediaId + '/default.jpg';
    case 'Vidyard':
      return 'https://play.vidyard.com/' + mediaId + '.jpg';
    case 'Vimeo':
      return 'https://i.vimeocdn.com/video/' + mediaId + '.jpg';
    case 'Wistia':
      return 'https://fast.wistia.net/oembed?url=http://home.wistia.com/medias/' + mediaId + '.jpg';
    default:
      throwDevelopmentOrLog(new Error(`Unknown video type '${videoType}'`));
  }
  return '';
}
export function extractMediaId(mediaUrl) {
  if (!mediaUrl) {
    return '';
  }
  if (mediaUrl.startsWith(ASSET_STORAGE_URL)) {
    return mediaUrl.slice(mediaUrl.lastIndexOf('/') + 1);
  }
  throwDevelopmentOrLog(new Error(`URL '${mediaUrl}' DOES NOT start with '${ASSET_STORAGE_URL}'`));
  return mediaUrl;
}